import type { FC } from 'react';
import { Show } from '@components/Show';
import Tooltip from '@components/Tooltip';
import { SwitchHorizontalIcon } from '@heroicons/react/solid';

import type { DragHandleProps } from './types';

/**
 * Drag handle component for column reordering - shows on hover with tooltip.
 */
export const DragHandle: FC<DragHandleProps> = ({ isDraggable, listeners, attributes }) => {
  return (
    <Show when={isDraggable}>
      <Tooltip content="Drag and drop to re-order column" placement="top">
        <div
          {...listeners}
          {...attributes}
          className="mr-0.5 cursor-grab rounded p-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100 hover:bg-gray-200 active:cursor-grabbing"
          onClick={(e) => e.preventDefault()}
          role="button"
          tabIndex={0}
          aria-label="Drag to reorder column"
        >
          <SwitchHorizontalIcon className="h-4 w-4 text-gray-400" />
        </div>
      </Tooltip>
    </Show>
  );
};
